import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import PayorCreateForm from "../-form";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { getGetPayorQueryOptions } from "@/requests/gen/react-query/payor";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import { PayorCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute("/_private/_admin/payor/$payorId/edit")({
  loader: ({ context: { queryClient }, params: { payorId } }) =>
    queryClient.ensureQueryData(getGetPayorQueryOptions(numericId(payorId))),
  component: PayorEditPage,
});

function PayorEditPage() {
  const { payorId } = Route.useParams();
  const navigate = useNavigate();
  const { data: payor } = useSuspenseQuery(
    suspenseOptions(getGetPayorQueryOptions(numericId(payorId))),
  );

  return (
    <div>
      <title>Edit Payor - Legrande Health Portal</title>
      <PayorCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Payor</CardTitle>
          <CardDescription>Enter payor details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {payor && (
            <PayorCreateForm
              payor={payor}
              onSuccess={(response) => {
                navigate({
                  to: "/payor/$payorId",
                  params: { payorId: String(response.payor_id) },
                });
              }}
              onCancelBtn={
                <Button variant="outline" asChild>
                  <Link to="/payor/$payorId" params={{ payorId }}>
                    Cancel
                  </Link>
                </Button>
              }
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
